import { previewKind } from '@/shared/attachment-preview/preview-kind';

import { FileCard } from './file-card';

export interface MediaFileProps {
  name: string;
  mime: string;
  url: string | null;
  linkCard?: boolean;
  onOpen?: () => void;
}

const CAPTION_CLASS = 'mt-1 text-sm text-foreground-muted';

export function MediaFile({ name, mime, url, linkCard = false, onOpen }: MediaFileProps) {
  const kind = previewKind(mime, name);
  if (url === null || url === '') {
    return <FileCard name={name} mime={mime} onOpen={onOpen} />;
  }
  if (kind === 'image') {
    return (
      <figure data-media="image" className="my-1">
        <img src={url} alt={name} loading="lazy" draggable={false} className="max-w-full rounded-md" />
        <figcaption className={CAPTION_CLASS}>{name}</figcaption>
      </figure>
    );
  }
  if (kind === 'video') {
    return <video data-media="video" src={url} controls preload="metadata" aria-label={name} className="my-1 max-w-full rounded-md" />;
  }
  if (kind === 'audio') {
    return (
      <figure data-media="audio" className="my-1">
        <audio src={url} controls preload="metadata" aria-label={name} className="w-full" />
        <figcaption className={CAPTION_CLASS}>{name}</figcaption>
      </figure>
    );
  }
  return <FileCard name={name} mime={mime} href={linkCard ? url : undefined} onOpen={onOpen} />;
}
